var _rect, _rect2, _rect3, _rect4, _path, _line, _line2, _line3, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 121,
    viewBox: "0 0 147 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 121,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 44,
    height: 4,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 36,
    width: 44,
    height: 4,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 25,
    height: 3,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 90.5H128C128.828 90.5 129.5 91.1716 129.5 92V120.5H19.5V92C19.5 91.1716 20.1716 90.5 21 90.5Z",
    stroke: "#E0E0E0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 100.5,
    x2: 130,
    y2: 100.5,
    stroke: "#E0E0E0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 110.5,
    x2: 130,
    y2: 110.5,
    stroke: "#E0E0E0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 120.5,
    x2: 130,
    y2: 120.5,
    stroke: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 73,
    width: 75,
    height: 6,
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.3e6859d77c83220b55b8d18a1d9b5e04.svg";
export { ForwardRef as ReactComponent };